
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 984.85 984.85"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M652.075 954.791c12.101 12 28.7 20.1 45.7 21.5 17.2 1.399 34.9-2.8 49.2-12.5 3.9-2.601 7.6-5.7 10.9-9l.1-.101 204.9-204.899c29.3-29.3 29.3-76.8 0-106.101-29.301-29.3-76.801-29.3-106.101 0l-76.899 76.9v-637c0-41.4-33.601-75-75-75-41.4 0-75 33.6-75 75v637l-78.9-78.9c-29.3-29.3-76.8-29.3-106.1 0-29.301 29.301-29.301 76.801 0 106.101l207 207c.1-.101.1 0 .2 0z"}}),_c('path',{attrs:{"d":"M74.975 365.491c19.2 0 38.4-7.3 53-22l78.9-78.9v637c0 41.4 33.6 75 75 75s75-33.6 75-75v-637l76.899 76.9c14.601 14.6 33.8 22 53 22s38.4-7.3 53-22c29.3-29.3 29.3-76.8 0-106.1l-16.3-16.3c-13.3-13.3-26.5-26.7-39.9-39.9-17.199-17.1-34.3-34.2-51.399-51.4-16.8-17-34.2-33.5-50.9-50.7-16.2-16.6-32.6-32.9-49.899-48.5-18-16.2-41.5-24.2-65.7-18.5-6.2 1.4-12.8 3.8-18.4 6.9-16.7 9.4-30 24.9-43.5 38.3-16.5 16.3-32.7 32.9-49.1 49.4-19.5 19.6-39.2 39.1-58.8 58.6-16.4 16.6-33 33.2-49.5 49.8-8 8-16 15.9-24 23.9l-.4.4c-29.3 29.3-29.3 76.8 0 106.1 14.599 14.7 33.799 22 52.999 22z"}})])
          )
        }
      }
    